<div class="wiz-component-container" width="100%" height="100%">
  <div class="wiz-component-label" width="100%" *ngIf="wizShowLabel">
    <wiz-label
      #innerLabel  id="label"
      [wizLabel]="wizLabel"
      [wizTextBehavior]="'truncate'"
      [ngClass]="{'error-class': hasErrors}"
    ></wiz-label
    ><!-- label -->
    <span
      #innerAsterisk
      *ngIf="wizMandatory && wizShowLabel"
      class="mandatory-class"
      >*</span
    ><!-- asterisque -->
  </div>

  <mat-form-field
    id="inzone"
    #formField
    floatLabel="never"
    width="100%"
    class="wiz-component-field"
    (click)="innerInputClick($event)"
    [ngClass]="{'error-class': hasErrors,
              'innerfocus-class': !wizDisabled,
              'innerchildfocus-class':popUpOpened}"
  >
    <!-- #trigger="wizAutocompleteTrigger" : alias de l'input pour déclencher ses méthodes relatives
    à la popUp : override du MatTrigger( lié à la directive [wizAutocomplete])
        ==> neutralisation de la gestion du clavier
    [wizAutocomplete]="dropPanel" référence HTML à l'autocomplete -->
    <input
      #innerInput
      matInput
      width="100%"
      type="text"
      class="wiz-input"
      [style.cursor]="this.wizShowSearchInput || this.wizDisabled ? '' : 'pointer'"
      [disabled]="wizDisabled"
      [placeholder]="translatedPlaceholder"
      [ngModel]="innerInputString"
      [autocomplete]="'off'"
      [readonly]="!wizShowSearchInput"
      #innerAsTrigger="wizAutocompleteTrigger"
      [wizAutocomplete]="dropPanel"
      [component]="this"
      (keydown)="_handleKeydown($event)"
      (keyup)="_handleKeyup($event)"
      (focus)="onFocus($event)"
      (blur)="onBlur($event)"
      [tabIndex]="wizTabIndex"
    />

    <!--popUp de la dropDown  -->
    <mat-autocomplete
      #dropPanel="matAutocomplete"
      [autoActiveFirstOption]="false"
      [panelWidth]="wizPanelWidth"
      (opened)="openPanel()"
      (closed)="closePanel()"
      (optionSelected)="optSelect($event)"
      [displayWith]="displayFn.bind(this)"
    >
      <!-- fake item  -->
      <mat-option
        [style.height.px]="itemHeight"
        tabindex="-1"
        *ngIf="showFakeItem()"
        class="dropdown-option"
        style="padding: 0px"
        [value]="'FAKE'"
      >
        <div
          #option
          style="padding: 0px 5px"
          height="100%"
          (click)="itemClick($event, 'FAKE')"
        >
          <!-- padding-left: 5px; pour avoir le même alignement que les labelField -->
          <wiz-label
            style="padding-left: 5px"
            width="100%"
            height="100%"
            [wizLabel]="wizFakeLabel"
          ></wiz-label>
        </div>
      </mat-option>

      <!-- select all -->
      <mat-option
        [style.height.px]="itemHeight"
        [style.line-height.px]="itemHeight"
        tabindex="-1"
        class="dropdown-option"
        style="padding: 0px"
        [value]="'SELECT_ALL'"
        *ngIf="showSelectAll()"
      >
        <div
          style="padding: 0px 5px"
          height="100%"
          (click)="$event.stopPropagation();"
        >
          <!-- neutralisation de la fermeture auto-->
          <wiz-checkbox
            #selectAllCheck
            [wizLabel]="'$.dropdown.select.all.$'"
            (click)="toggleSelectAll($event)"
          ></wiz-checkbox>
        </div>
      </mat-option>

      <!-- list -->
      <mat-option
        [style.height.px]="itemHeight"
        [style.line-height.px]="itemHeight"
        tabindex="-1"
        class="dropdown-option"
        style="padding: 0px"
        [value]="item"
        *ngFor="let item of wizDataProvider"
      >
        <div
          #option
          style="padding: 0px 5px; display: flex; align-items: center"
          height="100%"
          [ngClass]="{'selected-class': isPopUpSelected(item)}"
          (click)="itemClick($event, item)"
        >
          <wiz-checkbox
            *ngIf="isMultiSelection()"
            [wizShowLabel]="false"
            [wizChecked]="isSelected(item)"
            (click)="checkClick(item)"
          ></wiz-checkbox>
          <ng-container
            width="100%"
            *ngTemplateOutlet="getTemplate(); context: { $implicit: item, itemRenderer: wizItemRenderer }"
          >
          </ng-container>
        </div>
      </mat-option>
    </mat-autocomplete>

    <!-- icone clear search -->
    <mat-icon
      #innerClearIcon
      tabindex="-1"
      *ngIf="searchString()"
      class="innerIcon"
      [ngClass]="{'disabled-class': wizDisabled}"
      (click)="clearFilter($event)"
      >clear</mat-icon
    >

    <mat-icon
      #innerDownArrow
      tabindex="-1"
      class="innerIcon"
      *ngIf="!searchString()"
      [ngClass]="{'disabled-class': wizDisabled}"
      >keyboard_arrow_down</mat-icon
    >
  </mat-form-field>

  <div width="100%" class="wiz-component-hint" gap="0">
    <!-- le hint -->
    <wiz-label
      #innerhint
      class="hint-class"
      *ngIf="wizHint"
      [wizLabel]="wizHint"
    ></wiz-label>
    <!-- l'affichage de l'erreur -->
    <ng-container #errorContainer id="error"></ng-container>
  </div>
</div>

<!-- Template de base, affichage du labelField-->
<ng-template #defaultRenderer let-item>
  <span style="padding-left: 5px">{{getItemLabel(item)}}</span>
</ng-template>

<!-- Template utilisant un renderer custom -->
<ng-template #dynamicRenderer let-item let-itemrndr="itemRenderer">
  <!-- appel de la directive wizTemplateItemRenderer pour injection du renderer -->
  <div [wizTemplateItemRenderer]="itemrndr" [data]="item" [owner]="this"></div>
</ng-template>
